export const reportProperties = {
  reportName: '',
  reportDateRange: {
    start: '',
    end: '',
  },
  reportNotes: ''
};